<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex align-center justify-space-between title_date_report_work_list mb-3">
            <h2>เดือน {{ $store.state.monthList[new Date().getMonth()].name }} {{ new Date().getFullYear() + 543 }}</h2>
            <div class="d-flex justify-end option_date_report_work_list">
                <div class="mr-1">
                    <v-select label="เลือกปี" :items="yearList" item-text="name_be" item-value="name" v-model="year" @change="reportWorkList()" color="primary" hide-details="auto" outlined>
                    </v-select>
                </div>
                <div class="ml-1">
                    <v-select label="เลือกเดือน" :items="$store.state.monthList" v-model="month" @change="reportWorkList()" item-text="name" item-value="id" color="primary" hide-details="auto" outlined>
                    </v-select>
                </div>
            </div>
        </div>

        <v-card>
            <div class="mb-2">
                <v-card-title>

                </v-card-title>
                <v-data-table :headers="headers" :items="data" :search="search">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.date_show}}</td>
                            <td>
                                <div v-for="(shift,index) in dataDetail.item.shift" :key="index">
                                    {{ shift.name }} {{ shift.count }} คน
                                </div>
                            </td>
                            <td>{{dataDetail.item.ot}}</td>
                            <td>
                                <span class="cursor_date_report_work_list" @click="detailReportWork(dataDetail.item.created_at)">
                                    <v-icon right color="grey">mdi-eye</v-icon>
                                </span>
                                <span class="cursor_date_report_work_list" @click="editReportWork(dataDetail.item.created_at)">
                                    <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-card>
    </div>
</div>
</template>

<script>
import reportwork from '@/api/team/teamreportsummary/reportwork.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            search: '',
            headers: [{
                    text: 'วันที่',
                    align: 'start',
                    value: 'date_show',
                },
                {
                    text: 'รายการ',
                    value: 'shift'
                },
                {
                    text: 'OT',
                    value: 'type'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async reportWorkList() {
            this.loading_page = false
            this.data = []
            reportwork.reportWorkList(this.year, this.month).then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.workTimeList
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailReportWork(date){
            let date_time = date.split(" ")
            const datePage = {
                date: date_time[0]
            }
            this.$store.commit('detailReportWorkPage', datePage)
            this.$router.push('/detailreportwork')
        },
        async editReportWork(date){
             let date_time = date.split(" ")
            const datePage = {
                date: date_time[0]
            }
            this.$store.commit('editReportWorkPage', datePage)
            this.$router.push('/editreportwork')
        },
    },
    computed: {
        yearList() {
            const last_year = new Date().getFullYear()
            let year_list = new Array()
            for (let index = 2020; index <= last_year; index++) {
                year_list.push({
                    name:index,
                    name_be:index + 543
                })

            }
            return year_list
        }
    },
    mounted() {
        this.reportWorkList()
    }
}
</script>

<style scoped>
.title_date_report_work_list>h2 {
    width: 50%;
}

.title_date_report_work_list>div {
    width: 50%;
}

.option_date_report_work_list>div {
    width: 40%;
}

.cursor_date_report_work_list{
    cursor: pointer;
}
</style>
